import getApiUrl from "./getApiUrl";

const getStaticFileUrl = (fileName: string): string =>
  `${getApiUrl()}/static/block-file/${fileName}`;

export default getStaticFileUrl;
